'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.maskCorner = twentyninetimes.maskCorner || function () {

	function init() {
		const maskCornerElements = document.querySelectorAll('.is-style-mask-corner-top-left, .is-style-mask-corner-top-right, .is-style-mask-corner-bottom-left, .is-style-mask-corner-bottom-right');

		if ( maskCornerElements.length > 0 ) {
      addMaskCornerSpan(maskCornerElements);
		}
	}

	function addMaskCornerSpan(elements) {
    elements.forEach((element) => {
      var spanElm = document.createElement('span');
      spanElm.classList.add('mask-corner');

      if ( element.classList.contains('is-style-mask-corner-top-left') ) {
        spanElm.classList.add('mask-corner--top-left');
      } else if ( element.classList.contains('is-style-mask-corner-top-right') ) {
        spanElm.classList.add('mask-corner--top-right');
      } else if ( element.classList.contains('is-style-mask-corner-bottom-left') ) {
        spanElm.classList.add('mask-corner--bottom-left');
      } else if ( element.classList.contains('is-style-mask-corner-bottom-right') ) {
        spanElm.classList.add('mask-corner--bottom-right');
      }

      // check if element is a figure else find the first figure
      if ( element.tagName.toLowerCase() === 'figure' ) {
        element.appendChild(spanElm);
      } else {
        var figureElm = element.querySelector('figure');
        if ( figureElm ) {
          figureElm.appendChild(spanElm);
        }
      }
    });
	}

	return {
		init : init
	};

}();